export const MDM_SCRIPTS = {
  TITLE: 'Scripts',
  SUBTITLE: 'Configure y ejecute scripts en toda su organización',
  SEARCH_PLACEHOLDER: 'Buscar scripts...',
  NEW_SCRIPT: 'Nuevo Script',
  RUN: 'Ejecutar',
  RUN_SCRIPT: 'Ejecutar Script',
  SCRIPT_DETAILS: 'Detalles del Script',
  NO_SCRIPT_CONTENT: 'Sin contenido de script',
  SECTIONS: {
    RUN_HISTORY: 'Historial de Ejecuciones',
  },
}

export const MDM_SCRIPTS_TABLE = {
  NAME: 'Nombre',
  PLATFORM: 'Plataforma',
  STATUS: 'Estado',
  LAST_RUN: 'Última Ejecución',
  RUNS: 'Ejecuciones',
  NO_RUNS: 'Sin ejecuciones',
  RUNS_COUNT: (count: number) => `${count} ejecuciones`,
}

export const MDM_SCRIPTS_SUMMARY = {
  RUNS: 'Ejecuciones',
  SUCCESSFUL: 'Exitosas',
  FAILED: 'Fallidas',
}

export const MDM_SCRIPTS_STATUS = {
  SUCCESS: 'Éxito',
  ERROR: 'Error',
  NOT_RUN: 'Sin ejecutar',
}

export const MDM_SCRIPTS_PLATFORMS = {
  MACOS: 'macOS',
  WINDOWS: 'Windows',
  LINUX: 'Linux',
  ALL_PLATFORMS: 'Todas las plataformas',
}

export const MDM_SCRIPTS_RUN_STATUS_BAR = {
  HOSTS_SUCCEEDED: 'hosts exitosos',
  HOSTS_FAILED: 'hosts fallidos',
}

export const MDM_SCRIPTS_RUN_DIALOG = {
  RUN_PREFIX: 'Ejecutar',
  DESCRIPTION_COMPLETE: 'El script ha sido encolado para su ejecución.',
  DESCRIPTION_SELECT: 'Revisa el script y selecciona los grupos donde ejecutarlo.',
  SEARCH_GROUPS: 'Buscar grupos...',
  DONE: 'Listo',
  CANCEL: 'Cancelar',
  RUNNING: 'Ejecutando...',
  QUEUED: 'Encolado',
}

export const MDM_SCRIPTS_DRAWER = {
  PLATFORM: 'Plataforma',
  CODE: 'Código',
  RUN_HISTORY: 'Historial de Ejecuciones',
  RUN_HISTORY_COUNT: (count: number) => `Historial de Ejecuciones (${count})`,
  HOSTS: 'Hosts',
  SUCCEEDED: 'exitosos',
  FAILED: 'fallidos',
  NO_RUNS: 'Sin ejecuciones',
  LOADING_HOST_RESULTS: 'Cargando resultados de hosts...',
  REFRESH: 'Actualizar',
  PENDING_HINT: 'Los hosts lo ejecutan en su próxima conexión, lo que puede tardar un rato',
}

export const MDM_SCRIPTS_RUN_ITEM = {
  RUN_PREFIX: 'Ejecución #',
  HOSTS: 'Hosts',
  SUCCEEDED: 'Exitosos',
  ERRORS: 'Errores',
  HOST_RESULTS: 'Resultados por Host',
  SUCCESS: 'Éxito',
  ERROR: 'Error',
  PENDING: 'Pendiente',
  CANCELED: 'Cancelado',
  INCOMPATIBLE: 'Incompatible',
  RAN: 'Ejecutados',
  EXECUTION_OUTPUT: 'Resultado de Ejecución',
  EXIT_CODE: 'Código de Salida',
  RUNTIME: 'Duración',
  SECONDS: 'segundos',
  OUTPUT: 'Salida',
  NO_OUTPUT: 'Sin salida disponible',
  LOADING_OUTPUT: 'Cargando resultado de ejecución...',
  HOST_TIMEOUT: 'Tiempo de espera agotado',
  SCRIPT_REMOVED: 'Script eliminado',
}

export const MDM_SCRIPTS_FORM = {
  NAME: 'Nombre',
  ENTER_SCRIPT_NAME: 'Ingresa el nombre del script',
  PLATFORM: 'Plataforma',
  SCRIPT_CONTENT: 'Contenido del Script',
  ENTER_SCRIPT_CONTENT: 'Ingresa el contenido del script',
  CREATE_SCRIPT: 'Crear Script',
  CANCEL: 'Cancelar',
}

export const MDM_SCRIPTS_MESSAGES = {
  CREATED: 'Script creado correctamente',
  FAILED_TO_CREATE: 'Error al crear el script',
  DELETED: 'Script eliminado correctamente',
  FAILED_TO_DELETE: 'Error al eliminar el script',
  NAME_CONFLICT: (name: string) => `Ya existe un script con el nombre "${name}", elige otro nombre.`,
}

export const MDM_SCRIPTS_DELETE_DIALOG = {
  TITLE: 'Eliminar Script',
  DESCRIPTION_PREFIX: '¿Estás seguro de que deseas eliminar',
  DESCRIPTION_SUFFIX: '? Esta acción no se puede deshacer.',
  CANCEL: 'Cancelar',
  CONFIRM: 'Eliminar',
}
